<script>
    // No reactive data needed for this static display
    
    let expandedSections = {
        monitor: false,
        backup: false,
        organize: false,
        music: false
    };
    
    function toggleSection(section) {
        expandedSections[section] = !expandedSections[section];
        expandedSections = expandedSections; // trigger reactivity
    }
    
    function copyScript() {
        const scriptText = `@echo off
REM Output directory - change this as needed
set OUTPUT_DIR=C:\\music\\hyperpop

REM Create output folder if it doesn't exist
if not exist "%OUTPUT_DIR%" mkdir "%OUTPUT_DIR%"

REM Run yt-dlp with audio extraction and 64k AAC encoding
yt-dlp -x --audio-format m4a --audio-quality 64K -a links.txt -o "%OUTPUT_DIR%\\%%(title)s.%%(ext)s"

echo All downloads and conversions at 64 kbps completed!
pause`;
        
        navigator.clipboard.writeText(scriptText).then(() => {
            // Show success feedback
            const button = document.querySelector('.copy-button');
            const originalText = button.innerHTML;
            button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>Copied!';
            button.style.background = 'rgba(76, 175, 80, 0.2)';
            button.style.borderColor = 'rgba(76, 175, 80, 0.4)';
            
            setTimeout(() => {
                button.innerHTML = originalText;
                button.style.background = '';
                button.style.borderColor = '';
            }, 2000);
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    }
    
    function copyMonitorScript() {
        const scriptText = `#!/bin/bash

#let first aug be path to dir, create default
SOURCE="\${1:-/home/joshzheng/sys_monitor}"
#let second aug be interval per check, default = 5
INTERVAL="\${2:-5}"
mkdir -p "$SOURCE"

# create log file with date
LOGFILE="$SOURCE/data_$(date +"%Y-%m-%d_%H-%M-%S").log"

# create function to parse data
get_info()&#123;
  #use pipes, -bn1 batch run once, awk to get cpu usage
  CPU=$(top -bn1 | grep "%Cpu(s)" | awk '&#123;print 100 - $8 "%"}')
  #show in megabytes, grep Mem line, and find % used
  MEM=$(free -m | awk '/Mem:/ &#123;printf "%.2f%%", $3/$2*100}')
  #disk file show human readable, grep then print the 5th field
  DISK=$(df -h / | grep "/dev" | awk '&#123;print $5}')
  echo "CPU: $CPU | MEM: $MEM | DISK: $DISK" >> "$LOGFILE"
}

#read user input, add prompt
read -p "enter number of checks: " COUNT

#check COUNT is valid using regex
if ! [[ "$COUNT" =~ ^[0-9]+$ ]]; then
  echo "input not valid, exiting"
  exit 1
fi

# loop number of counts and call get_info
for &#40;&#40; i=1; i&lt;=COUNT; i&#43;&#43; &#41;&#41;; do
  get_info
  sleep "$INTERVAL"
  echo "data collected for $i/$COUNT"
done
echo "monnitor complete" >> "$LOGFILE"
echo "logged all info in $LOGFILE"`;
        
        navigator.clipboard.writeText(scriptText).then(() => {
            // Show success feedback
            const buttons = document.querySelectorAll('.copy-button');
            const monitorButton = Array.from(buttons).find(btn => btn.textContent.includes('Copy Script') && btn.closest('.script-container').querySelector('h3').textContent === 'sys_monitor.sh');
            if (monitorButton) {
                const originalText = monitorButton.innerHTML;
                monitorButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>Copied!';
                monitorButton.style.background = 'rgba(76, 175, 80, 0.2)';
                monitorButton.style.borderColor = 'rgba(76, 175, 80, 0.4)';
                
                setTimeout(() => {
                    monitorButton.innerHTML = originalText;
                    monitorButton.style.background = '';
                    monitorButton.style.borderColor = '';
                }, 2000);
            }
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    }
    
    function copyBashScript() {
        const scriptText = `#!/bin/bash

SOURCE="/home/joshzheng/cmsc330fall25"

DEST="/home/joshzheng/backups"

mkdir -p "$DEST"

TIMESTAMP=$(date +"%Y-%m-%d_%H-%M-%S")

BACKUP_FOLDER="$DEST/backup_$TIMESTAMP"

mkdir "$BACKUP_FOLDER"

cp -r "$SOURCE"/* "$BACKUP_FOLDER"

echo "Backup completed successfully to $BACKUP_FOLDER"`;
        
        navigator.clipboard.writeText(scriptText).then(() => {
            // Show success feedback
            const buttons = document.querySelectorAll('.copy-button');
            const bashButton = Array.from(buttons).find(btn => btn.textContent.includes('Copy Script') && btn.closest('.script-container').querySelector('h3').textContent === 'backup_330.sh');
            if (bashButton) {
                const originalText = bashButton.innerHTML;
                bashButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>Copied!';
                bashButton.style.background = 'rgba(76, 175, 80, 0.2)';
                bashButton.style.borderColor = 'rgba(76, 175, 80, 0.4)';
                
                setTimeout(() => {
                    bashButton.innerHTML = originalText;
                    bashButton.style.background = '';
                    bashButton.style.borderColor = '';
                }, 2000);
            }
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    }
    
    function copyOrganizeScript() {
        const scriptText = `#!/bin/bash

SOURCE="\${1:-/home/joshzheng/test}"
LOGFILE="$SOURCE/organize.log"

if [ ! -d "$SOURCE" ]; then
  echo "$SOURCE doesn't exist"
  #on error exit as 1
  exit 1
fi

echo "Initiate organize for $SOURCE" >> "$LOGFILE"
echo "Date: $(date)" >> "$LOGFILE"

for FILE in "$SOURCE"/*; do

  #skip directories
  [ -d "$FILE" ] && continue

  #skip the log file (this took so long to figure out)
  [ "$(basename "$FILE")" = "organize.log" ] && continue

  #find the extentions
  EXT="\${FILE##*.}"

  #compare EXT with FILE to create category for files with no extension
  [ "$EXT" = "$FILE" ] && EXT="others"

  #create new dir and move file
  mkdir -p "$SOURCE/$EXT"
  mv "$FILE" "$SOURCE/$EXT"

  echo "moved $(basename "$FILE") to $SOURCE/$EXT" >> "$LOGFILE"
done

echo "Completed organizing $SOURCE"`;
        
        navigator.clipboard.writeText(scriptText).then(() => {
            // Show success feedback
            const buttons = document.querySelectorAll('.copy-button');
            const organizeButton = Array.from(buttons).find(btn => btn.textContent.includes('Copy Script') && btn.closest('.script-container').querySelector('h3').textContent === 'organize_files.sh');
            if (organizeButton) {
                const originalText = organizeButton.innerHTML;
                organizeButton.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>Copied!';
                organizeButton.style.background = 'rgba(76, 175, 80, 0.2)';
                organizeButton.style.borderColor = 'rgba(76, 175, 80, 0.4)';
                
                setTimeout(() => {
                    organizeButton.innerHTML = originalText;
                    organizeButton.style.background = '';
                    organizeButton.style.borderColor = '';
                }, 2000);
            }
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    }
</script>

<div class="enlighten-section">
    <div class="section-header">
        <h1 class="enlighten-title">Scripts</h1>
        <p class="enlighten-subtitle">Scripting & Automation Collection</p>
    </div>
    
    <div class="scripting-category">
        <div class="category-header" on:click={() => toggleSection('monitor')}>
            <h2 class="category-title">
                <svg class="toggle-icon" class:rotated={!expandedSections.monitor} width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
                </svg>
                System Monitor Script<span class="script-type">(bash)</span>
            </h2>
        </div>
        
        {#if expandedSections.monitor}
            <div class="script-container">
                <div class="script-header">
                    <h3>sys_monitor.sh</h3>
                    <div class="script-actions">
                        <button class="copy-button" on:click={() => copyMonitorScript()}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                            </svg>
                            Copy Script
                        </button>
                    </div>
                </div>
                
                <div class="script-content">
                    <pre><code>#!/bin/bash

#let first aug be path to dir, create default
SOURCE="$&#123;1:-/home/joshzheng/sys_monitor}"
#let second aug be interval per check, default = 5
INTERVAL="$&#123;2:-5}"
mkdir -p "$SOURCE"

# create log file with date
LOGFILE="$SOURCE/data_$(date +"%Y-%m-%d_%H-%M-%S").log"

# create function to parse data
get_info()&#123;
  #use pipes, -bn1 batch run once, awk to get cpu usage
  CPU=$(top -bn1 | grep "%Cpu(s)" | awk '&#123;print 100 - $8 "%"}')
  #show in megabytes, grep Mem line, and find % used
  MEM=$(free -m | awk '/Mem:/ &#123;printf "%.2f%%", $3/$2*100}')
  #disk file show human readable, grep then print the 5th field
  DISK=$(df -h / | grep "/dev" | awk '&#123;print $5}')
  echo "CPU: $CPU | MEM: $MEM | DISK: $DISK" >> "$LOGFILE"
}

#read user input, add prompt
read -p "enter number of checks: " COUNT

#check COUNT is valid using regex
if ! [[ "$COUNT" =~ ^[0-9]+$ ]]; then
  echo "input not valid, exiting"
  exit 1
fi

# loop number of counts and call get_info
for &#40;&#40; i=1; i&lt;=COUNT; i&#43;&#43; &#41;&#41;; do
  get_info
  sleep "$INTERVAL"
  echo "data collected for $i/$COUNT"
done
echo "monnitor complete" >> "$LOGFILE"
echo "logged all info in $LOGFILE"</code></pre>
                </div>
                
                <div class="script-description">
                    <h4>Script Overview</h4>
                    <p>This bash script monitors system resources (CPU, Memory, Disk) and logs the data:</p>
                    <ul>
                        <li><strong>Flexible Parameters:</strong> Takes directory path and interval as arguments</li>
                        <li><strong>CPU Monitoring:</strong> Uses top command to get CPU usage percentage</li>
                        <li><strong>Memory Monitoring:</strong> Uses free command to get memory usage percentage</li>
                        <li><strong>Disk Monitoring:</strong> Uses df command to get disk usage percentage</li>
                        <li><strong>Timestamped Logging:</strong> Creates log files with date/time stamps</li>
                        <li><strong>User Input Validation:</strong> Validates number of checks using regex</li>
                        <li><strong>Progress Tracking:</strong> Shows progress during monitoring</li>
                    </ul>
                    
                    <div class="requirements">
                        <h4>Usage Examples</h4>
                        <ul>
                            <li><code>./sys_monitor.sh</code> - Uses default directory and 5-second intervals</li>
                            <li><code>./sys_monitor.sh /custom/path</code> - Custom directory, 5-second intervals</li>
                            <li><code>./sys_monitor.sh /custom/path 10</code> - Custom directory and 10-second intervals</li>
                        </ul>
                    </div>
                </div>
            </div>
        {/if}
    </div>
    
    <div class="scripting-category">
        <div class="category-header" on:click={() => toggleSection('organize')}>
            <h2 class="category-title">
                <svg class="toggle-icon" class:rotated={!expandedSections.organize} width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
                </svg>
                File Organization System <span class="script-type">(bash)</span>
            </h2>
        </div>
        
        {#if expandedSections.organize}
            <div class="script-container">
                <div class="script-header">
                    <h3>organize_files.sh</h3>
                    <div class="script-actions">
                        <button class="copy-button" on:click={() => copyOrganizeScript()}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                            </svg>
                            Copy Script
                        </button>
                    </div>
                </div>
                
                <div class="script-content">
                    <pre><code>#!/bin/bash

SOURCE="$&#123;1:-/home/joshzheng/test}"
LOGFILE="$SOURCE/organize.log"

if [ ! -d "$SOURCE" ]; then
  echo "$SOURCE doesn't exist"
  #on error exit as 1
  exit 1
fi

echo "Initiate organize for $SOURCE" >> "$LOGFILE"
echo "Date: $(date)" >> "$LOGFILE"

for FILE in "$SOURCE"/*; do

  #skip directories
  [ -d "$FILE" ] && continue

  #skip the log file (this took so long to figure out)
  [ "$(basename "$FILE")" = "organize.log" ] && continue

  #find the extentions
  EXT="$&#123;FILE##*.}"

  #compare EXT with FILE to create category for files with no extension
  [ "$EXT" = "$FILE" ] && EXT="others"

  #create new dir and move file
  mkdir -p "$SOURCE/$EXT"
  mv "$FILE" "$SOURCE/$EXT"

  echo "moved $(basename "$FILE") to $SOURCE/$EXT" >> "$LOGFILE"
done

echo "Completed organizing $SOURCE"</code></pre>
                </div>
                
                <div class="script-description">
                    <h4>Script Overview</h4>
                    <p>This bash script automatically organizes files by their extensions into separate directories:</p>
                    <ul>
                        <li><strong>Flexible Source:</strong> Takes directory path as argument (defaults to /home/joshzheng/test)</li>
                        <li><strong>Extension Detection:</strong> Identifies file extensions and creates corresponding folders</li>
                        <li><strong>Logging:</strong> Creates organize.log file to track all file movements</li>
                        <li><strong>Smart Filtering:</strong> Skips directories and the log file itself</li>
                        <li><strong>No Extension Handling:</strong> Files without extensions go to "others" folder</li>
                        <li><strong>Error Handling:</strong> Exits with error code if source directory doesn't exist</li>
                    </ul>
                    
                    <div class="requirements">
                        <h4>Usage Examples</h4>
                        <ul>
                            <li><code>./organize_files.sh</code> - Organizes files in default directory</li>
                            <li><code>./organize_files.sh /path/to/folder</code> - Organizes files in specified directory</li>
                            <li>Creates folders like: txt/, pdf/, jpg/, others/</li>
                        </ul>
                    </div>
                </div>
            </div>
        {/if}
    </div>
    
    <div class="scripting-category">
        <div class="category-header" on:click={() => toggleSection('backup')}>
            <h2 class="category-title">
                <svg class="toggle-icon" class:rotated={!expandedSections.backup} width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
                </svg>
                Coursework Backup System <span class="script-type">(bash)</span>
            </h2>
        </div>
        
        {#if expandedSections.backup}
            <div class="script-container">
                <div class="script-header">
                    <h3>backup_330.sh</h3>
                    <div class="script-actions">
                        <button class="copy-button" on:click={() => copyBashScript()}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                            </svg>
                            Copy Script
                        </button>
                    </div>
                </div>
                
                <div class="script-content">
                    <pre><code>#!/bin/bash

SOURCE="/home/joshzheng/cmsc330fall25"

DEST="/home/joshzheng/backups"

mkdir -p "$DEST"

TIMESTAMP=$(date +"%Y-%m-%d_%H-%M-%S")

BACKUP_FOLDER="$DEST/backup_$TIMESTAMP"

mkdir "$BACKUP_FOLDER"

cp -r "$SOURCE"/* "$BACKUP_FOLDER"

echo "Backup completed successfully to $BACKUP_FOLDER"</code></pre>
                </div>
                
                <div class="script-description">
                    <h4>Script Overview</h4>
                    <p>This bash script automates the backup process for CMSC 330 coursework:</p>
                    <ul>
                        <li><strong>Source Directory:</strong> /home/joshzheng/cmsc330fall25 (coursework folder)</li>
                        <li><strong>Destination:</strong> /home/joshzheng/backups (configurable backup location)</li>
                        <li><strong>Timestamping:</strong> Creates unique backup folders with date/time stamps</li>
                        <li><strong>Recursive Copy:</strong> Copies all files and subdirectories</li>
                        <li><strong>Directory Creation:</strong> Automatically creates backup directories if they don't exist</li>
                    </ul>
                    
                    <div class="requirements">
                        <h4>Extension Possibilities</h4>
                        <p>Currently backs up locally. Could be extended to backup to:</p>
                        <ul>
                            <li>Another server via SSH/SCP</li>
                            <li>Cloud storage (AWS S3, GCP, Azure)</li>
                            <li>VPS (Virtual Private Server)</li>
                        </ul>
                    </div>
                </div>
            </div>
        {/if}
    </div>
    
    <div class="scripting-category">
        <div class="category-header" on:click={() => toggleSection('music')}>
            <h2 class="category-title">
                <svg class="toggle-icon" class:rotated={!expandedSections.music} width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
                </svg>
                Music Download Automation <span class="script-type">(batch)</span>
            </h2>
        </div>
        
        {#if expandedSections.music}
            <div class="script-container">
                <div class="script-header">
                    <h3>download_64k.bat</h3>
                    <div class="script-actions">
                        <button class="copy-button" on:click={() => copyScript()}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                            </svg>
                            Copy Script
                        </button>
                    </div>
                </div>
                
                <div class="script-content">
                    <pre><code>@echo off
REM Output directory - change this as needed
set OUTPUT_DIR=C:\music\hyperpop

REM Create output folder if it doesn't exist
if not exist "%OUTPUT_DIR%" mkdir "%OUTPUT_DIR%"

REM Run yt-dlp with audio extraction and 64k AAC encoding
yt-dlp -x --audio-format m4a --audio-quality 64K -a links.txt -o "%OUTPUT_DIR%\%%(title)s.%%(ext)s"

echo All downloads and conversions at 64 kbps completed!
pause</code></pre>
                </div>
                
                <div class="script-description">
                    <h4>Script Overview</h4>
                    <p>This batch script automates the process of downloading and converting audio files using yt-dlp:</p>
                    <ul>
                        <li><strong>Output Directory:</strong> Configurable path for downloaded files (default: C:\music\hyperpop)</li>
                        <li><strong>Audio Format:</strong> Converts to M4A format with 64kbps quality</li>
                        <li><strong>Input Source:</strong> Reads URLs from links.txt file</li>
                        <li><strong>File Naming:</strong> Uses video titles as filenames</li>
                        <li><strong>Error Handling:</strong> Creates output directory if it doesn't exist</li>
                    </ul>
                    
                    <div class="requirements">
                        <h4>Requirements</h4>
                        <ul>
                            <li>yt-dlp installed and accessible in PATH</li>
                            <li>links.txt file with one URL per line</li>
                            <li>Sufficient disk space for audio files</li>
                        </ul>
                    </div>
                </div>
            </div>
        {/if}
    </div>
</div>


<style>
    .enlighten-section {
        padding: 2rem 0;
        max-width: 1000px;
        margin: 0 auto;
    }

    .section-header {
        text-align: center;
        margin-bottom: 2rem;
    }

    .enlighten-title {
        font-size: 2.5rem;
        font-weight: 700;
        margin: 0 0 1rem 0;
        background: linear-gradient(135deg, #64b5f6, #42a5f5);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        line-height: 1.2;
    }

    .enlighten-subtitle {
        font-size: 1.1rem;
        color: #b0b0b0;
        margin: 0;
        font-weight: 400;
    }

    .scripting-category {
        margin-bottom: 2rem;
    }

    .category-header {
        background: rgba(100, 181, 246, 0.1);
        border: 1px solid rgba(100, 181, 246, 0.2);
        border-radius: 12px;
        padding: 1rem 1.5rem;
        cursor: pointer;
        transition: all 0.3s ease;
        margin-bottom: 1rem;
    }

    .category-header:hover {
        background: rgba(100, 181, 246, 0.15);
        border-color: rgba(100, 181, 246, 0.3);
        transform: translateY(-1px);
    }

    .category-title {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        margin: 0;
        color: #64b5f6;
        font-size: 1.3rem;
        font-weight: 600;
    }

    .toggle-icon {
        transition: transform 0.3s ease;
        color: #64b5f6;
    }

    .toggle-icon.rotated {
        transform: rotate(-90deg);
    }

    .script-type {
        font-size: 0.9rem;
        font-weight: 400;
        color: #90caf9;
        margin-left: 0.5rem;
        opacity: 0.8;
    }

    .script-container {
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 16px;
        padding: 0;
        backdrop-filter: blur(10px);
        overflow: hidden;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    }

    .script-header {
        background: rgba(100, 181, 246, 0.1);
        border-bottom: 1px solid rgba(100, 181, 246, 0.2);
        padding: 1rem 1.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .script-header h3 {
        margin: 0;
        color: #64b5f6;
        font-size: 1.1rem;
        font-weight: 600;
    }

    .script-actions {
        display: flex;
        gap: 0.5rem;
    }

    .copy-button {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.5rem 1rem;
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 8px;
        color: #ffffff;
        font-size: 0.9rem;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .copy-button:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: translateY(-1px);
    }

    .script-content {
        padding: 1.5rem;
        background: #0a0a0a;
        border-radius: 0 0 16px 16px;
    }

    .script-content pre {
        margin: 0;
        overflow-x: auto;
        font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
        font-size: 0.9rem;
        line-height: 1.5;
        color: #e0e0e0;
    }

    .script-content code {
        color: inherit;
        background: none;
        padding: 0;
        border-radius: 0;
    }

    .script-description {
        padding: 1.5rem;
        background: rgba(255, 255, 255, 0.02);
    }

    .script-description h4 {
        color: #ffffff;
        font-size: 1.2rem;
        font-weight: 600;
        margin: 0 0 1rem 0;
    }

    .script-description p {
        color: #b0b0b0;
        line-height: 1.6;
        margin: 0 0 1rem 0;
    }

    .script-description ul {
        color: #b0b0b0;
        line-height: 1.6;
        margin: 0 0 1.5rem 0;
        padding-left: 1.5rem;
    }

    .script-description li {
        margin-bottom: 0.5rem;
    }

    .script-description strong {
        color: #64b5f6;
        font-weight: 600;
    }

    .requirements {
        background: rgba(100, 181, 246, 0.05);
        border: 1px solid rgba(100, 181, 246, 0.2);
        border-radius: 8px;
        padding: 1rem;
        margin-top: 1rem;
    }

    .requirements h4 {
        color: #64b5f6;
        font-size: 1rem;
        margin: 0 0 0.75rem 0;
    }

    .requirements ul {
        margin: 0;
        font-size: 0.9rem;
    }

    @media only screen and (max-width: 768px) {
        .enlighten-section {
            padding: 1.5rem 0;
        }

        .enlighten-title {
            font-size: 2rem;
        }

        .script-header {
            flex-direction: column;
            gap: 1rem;
            align-items: flex-start;
        }

        .script-content {
            padding: 1rem;
        }

        .script-description {
            padding: 1rem;
        }

        .script-content pre {
            font-size: 0.8rem;
        }
    }
</style>
